import CrudRepository from './CrudRepository'
import Repository from './Repository'
export default class BundlesDetailsRepository extends CrudRepository {
  constructor () {
    super('/core/api/bundles/details/')
  }

  async getBundleDetails (id, gsm) {
    const data = await Repository.get(`${this.resource}${id}/web`, { params: gsm ? { gsm: gsm } : {} })
    return data.data
  }
}
